import {
  useGetAllProductsQuery,
  useGetEntitlementsQuery,
  type EntitlementsResponse,
  type ProductsResponse,
} from '../../services/entitlementsApi';
import { useSelector } from 'react-redux';
import splitsList from '../../constants/splits';
import type { RootStateWithSplitTreatments } from '../../types/state';

type UseFlexDataResult = {
  isNewDesignEnabled: boolean;
  isFlexUser: boolean;
  entitlements: EntitlementsResponse | undefined;
  products: ProductsResponse | undefined;
  entitlementsError: unknown;
  flexDataError: unknown;
  isFlexDataReady: boolean;
};

type UseFlexDataOptions = {
  // when true, defers firing any of the underlying flex queries (e.g. until splits are ready)
  skip?: boolean;
};

const useFlexData = ({ skip = false }: UseFlexDataOptions = {}): UseFlexDataResult => {
  const isNewDesignEnabled = useSelector(
    (state: RootStateWithSplitTreatments) => state.split?.treatments?.[splitsList.prodmoveNewDesign] === true
  );
  const isFlexUser = isNewDesignEnabled;

  const shouldSkipFlexQueries = skip || !isNewDesignEnabled;

  const {
    data: products,
    isSuccess: productsSuccess,
    error: productsError,
  } = useGetAllProductsQuery(undefined, {
    skip: shouldSkipFlexQueries,
  });

  const {
    data: entitlements,
    isSuccess: entitlementsSuccess,
    error: entitlementsError,
  } = useGetEntitlementsQuery(undefined, {
    skip: shouldSkipFlexQueries,
  });

  const flexDataError = (!shouldSkipFlexQueries && (entitlementsError || productsError)) || null;

  const isFlexDataReady = !skip && (!isNewDesignEnabled || (entitlementsSuccess && productsSuccess));

  return {
    isNewDesignEnabled, // being used (mobileRoutes)
    isFlexUser, // being used (mobile switch page)
    entitlements,
    products, // being used (mobile switch page)
    entitlementsError,
    flexDataError, // being used (mobileRoutes)
    isFlexDataReady, // being used (mobileRoutes)
  };
};

export default useFlexData;
